import { render } from "./FooterParalympic.vue?vue&type=template&id=afa6d82c&scoped=true"
import script from "./FooterParalympic.vue?vue&type=script&lang=js"
export * from "./FooterParalympic.vue?vue&type=script&lang=js"

import "./FooterParalympic.vue?vue&type=style&index=0&id=afa6d82c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa6d82c"]])

export default __exports__